import { StepperItem } from "./components";
import { StepProps } from "./Stepper.types";

interface StepperProps {
  steps: StepProps[];
}

export const Stepper = ({ steps }: StepperProps) => {
  return (
    <ul style={{ listStyle: "none", padding: 0 }}>
      {steps.map((step, index) => {
        const stepIndex = index;
        const totalSteps = steps.length;
        const prevStep = index !== 0 ? steps[index - 1] : undefined;

        return (
          <StepperItem
            {...step}
            stepIndex={stepIndex}
            totalSteps={totalSteps}
            prevStep={prevStep}
            key={`step_item.${index}`}
          />
        );
      })}
    </ul>
  );
};
